export default {
    email:'damien.roch@gmail.com',
    linkedinUrl:'https://www.linkedin.com/in/damienroch/',
    githubUrl: 'https://github.com/koryonik',
    stackoverflowUrl: 'https://stackoverflow.com/users/2315514/koryonik'
}